import { SxProps, useTheme } from "@mui/material/styles";
import { black, boxShadows, grey } from "designSystem/styles/color";
import { mergeSx } from "designSystem/styles/style-functions";
import Tooltip, { TooltipProps } from "designSystem/components/tooltip/Tooltip";
import React, { FunctionComponent } from "react";

const tooltipStyles = (theme): SxProps => {
	return {
		alignItems: "flex-start",
		backgroundColor: theme.palette.background.paper,
		border: `1px solid ${grey[400]}`,
		borderRadius: "3px",
		boxShadow: boxShadows.popper,
		color: black[100],
		display: "flex",
		flexDirection: "column",
		fontSize: 12,
		fontWeight: 400,
		lineHeight: "17px",
		margin: "8px 6px",
		maxWidth: 400,
	};
};

export interface HtmlTooltipProps extends TooltipProps { }

const HtmlTooltip: FunctionComponent<HtmlTooltipProps> = (props) => {
	const { slotProps, ...otherProps } = props;
	const tooltipProps = slotProps?.tooltip ? slotProps.tooltip : {};
	const tooltipPropSx = tooltipProps?.sx;
	const theme = useTheme();

	return (
		<Tooltip
			slotProps={{
				...slotProps,
				tooltip: {
					...tooltipProps,
					sx: mergeSx(tooltipPropSx, tooltipStyles(theme)),
				},
			}}
			{...otherProps}
		/>
	);
};

export default HtmlTooltip;
